<div class="tarefas-historicos width-100 height-100">
  <div class="container-header">
    <div class="pull-right text-muted">
      <a ng-click="tarefas.showEditTask()" ng-if="$root.permissions.tarefa.canManage">
        <i class="icon-newtask" aria-hidden="true"></i> Nova Tarefa
      </a>

    </div>

    <div class="title text-center">
      <h2>
        <strong>HISTÓRICO</strong>
      </h2>
    </div>
    <!-- Filtros -->
    <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
      <button type="button" class="btn" ng-disabled="disableInHistory()">
         {{(tarefas.filters.responsavel.nome_completo || 'Encarregado') | capitalize | characters:10}} <span class="caret"></span>
      </button>
      <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
        <li role="menuitem" ng-show="tarefas.filters.responsavel">
          <a ng-click="tarefas.setFilter('responsavel', null, $event)" href="#">Todos</a>
        </li>
        <li role="menuitem" ng-repeat="usuario in encarregados track by usuario.id">
          <a ng-click="tarefas.setFilter('responsavel', usuario, $event)" href="#">{{usuario.nome_completo | capitalize}}</a>
        </li>
      </ul>
    </div>

    <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
      <button type="button" class="btn" ng-disabled="disableInHistory()">
         {{(tarefas.filters.status.descricao || 'Status') | capitalize | characters:10}} <span class="caret"></span>
      </button>
      <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
        <li role="menuitem" ng-show="tarefas.filters.status">
          <a ng-click="tarefas.setFilter('status', null, $event)" href="#">Todos</a>
        </li>
        <li role="menuitem" ng-repeat="taskStatus in tarefas.status track by taskStatus.id">
          <a ng-click="tarefas.setFilter('status', taskStatus, $event)" href="#">{{taskStatus.label}}</a>
        </li>
      </ul>
    </div>

    <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
      <button type="button" class="btn" ng-disabled="disableInHistory()">
         {{(tarefas.filters.tipo.descricao || 'Tipo') | capitalize | characters:10}} <span class="caret"></span>
      </button>
      <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
        <li role="menuitem" ng-show="tarefas.filters.tipo">
          <a ng-click="tarefas.setFilter('tipo', null, $event)" href="#">Todos</a>
        </li>
        <li role="menuitem" ng-repeat="tipo in tarefas.tipos | orderBy:'descricao' track by tipo.id">
          <a ng-click="tarefas.setFilter('tipo', tipo, $event)" href="#">{{tipo.descricao}}</a>
        </li>
      </ul>
    </div>

    <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
      <button type="button" class="btn" ng-disabled="disableInHistory()">
        {{(tarefas.filters.gleba.descricao || 'Talhão') | capitalize | characters:10}} <span class="caret"></span>
      </button>
      <ul class="dropdown-menu-right" uib-dropdown-menu ng-hide="disableInHistory()">
        <li ng-show="tarefas.filters.gleba">
          <a ng-click="tarefas.setFilter('gleba', null, $event)">Todas</a>
        </li>
        <li ng-repeat="gleba in $root.currentPropriedade.glebas | orderBy:'descricao'">
          <a ng-click="tarefas.setFilter('gleba', gleba, $event)">{{gleba.descricao}}</a>
        </li>
      </ul>
    </div>

    <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
      <button type="button" class="btn" ng-disabled="disableInHistory()">
         {{(tarefas.period.periodo | date:'dd/MM/yyyy') || 'Período'}} <span class="caret"></span>
      </button>
      <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
        <li role="menuitem" ng-repeat="periodo in tarefas.filtroPeriodo">
          <a ng-click="tarefas.setPeriodo(periodo, $event)" href="#">{{::periodo.descricao | capitalize}}</a>
        </li>
        <li role="menuitem">
          <a ng-click="tarefas.openPeriodsFilter($event)" href="#">Customizado</a>
        </li>
      </ul>
    </div>
    <!-- Fim Filtros -->
  </div>

  <div class="{{ tarefas.selected.length > 0 ? 'no-padding' : '' }} container-body width-100">
    <div class="text-center margin" ng-if="tarefas.selected.length > 0">
      <p><b>{{tarefas.selected.length}}</b> selecionada(s).</p>
      <div class="btn-group">
        <button type="button" class="btn btn-white btn-sm" ng-click="tarefas.toggleAll()">
          <i class="fa" ng-class="tarefas.allSelected ? 'fa-check-square-o' : 'fa-square-o'"></i> Selecionar todas
        </button>
        <button type="button" class="btn btn-white btn-sm" ng-click="tarefas.deleteSelected()">
          <i class="fa fa-trash"></i> Remover
        </button>
      </div>
    </div>
    <!-- Lista tarefas -->
    <p class="text-center" ng-show="tarefas.tasks && !tarefas.tasks.length">
      <small>Nenhuma tarefa...</small>
    </p>

    <uib-accordion close-others="true" class="list-tarefas" id="list-task-history" ng-show="tarefas.tasks && tarefas.tasks.length">
      <div infinite-scroll="tarefas.loadTarefas()"
           infinite-scroll-parent="true"
           infinite-scroll-disabled="sidebar != 'tasks'">
        <uib-accordion-group
             class="panel-default panel-{{task.status.color}} {{task.status.color}} {{task.status.descricao === 'andamento' ? 'striped' : ''}}"
             is-open="task.open" ng-repeat="task in tarefas.tasks">
          <uib-accordion-heading>
            <div class="row">
              <div class="col-xs-1 text-center btn" style="padding: 7px" ng-click="tarefas.toggle($event, task)" ng-disabled="!['pendente', 'atrasado'].includes(task.status.descricao)">
                <i class="fa" ng-class="tarefas.selected.includes(task.id) ? 'fa-check-square-o' : 'fa-square-o'"></i>
              </div>
              <div class="col-xs-11" style="margin-top: 3px; padding-left: 5px;" ng-click="tarefas.showMarkers($event, task)">
                <i class="pull-left {{task.tipo.icon}} fa fa-2x" aria-hidden="true" ></i>
                <i class="pull-right fa fa-2x" ng-hide="task.loading" ng-class="{'fa-minus-circle': task.open, 'fa-plus-circle': !task.open}"></i>
                <span ng-show="task.loading">
                  <i class="pull-right fa fa-2x fa-spinner fa-spin"></i>
                </span>
                <span ng-repeat="gleba in task.glebas track by $index">
                  <span ng-show="gleba.gleba">
                    <span ng-show="$index">,</span>{{gleba.gleba.descricao | capitalize}} ({{gleba.gleba.area_total | number:0}} ha)
                  </span>
                  <span ng-hide="gleba.gleba">
                    <span ng-show="$index">,</span>{{gleba.descricao | capitalize}} ({{gleba.area_total | number:0}} ha)
                  </span>
                </span>
                <br>
                <small class="text-white">
                  <i class="fa fa-calendar"></i>
                  {{task.data_inicial | date:'dd/MM'}} à {{task.data_final | date:'dd/MM'}}
                </small>
              </div>
            </div>
            <div class="clearfix"></div>
          </uib-accordion-heading>

          <p>
            <a class="text-white" ng-if="task.status.descricao != 'finalizado' && $root.permissions.tarefa.canManage" ng-click="tarefas.finishTask($event, task)">
              A tarefa já foi realizada?
              <br>
            </a>
          </p>

          <p class="text-white" ng-show="task.finalizado_em && task.status.descricao == 'finalizado'">
            <small>
              Finalizado em {{task.finalizado_em | date: 'dd/MM/yyyy \'às\' HH:mm:ss'}}
            </small>
          </p>
          <p class="text-white" ng-show="task.status.descricao == 'andamento'">
            <small>Em andamento...</small>
          </p>

          <p>
            <span ng-if="task.insumo && task.insumo.descricao">
              <b>Cultivar: </b>{{task.insumo.descricao}}<br>
            </span>

            <span ng-if="task.acao">
              {{task.acao}}<br>
            </span>

            <span ng-if="task.pragas">
              <b>Pragas: </b>{{ task.nomes_pragas | capitalize }}<br>
            </span>

            <b>Período previsto: </b>{{task.data_inicial | date:'dd/MM/yyyy'}} até {{task.data_final | date:'dd/MM/yyyy'}}<br>

            <b>Responsável: </b>{{task.responsavel.nome_completo | capitalize}}<br>

            <span ng-if="task.nomes_encarregados">
              <b>Encarregados: </b>{{task.nomes_encarregados | capitalize}}<br>
            </span>

            <span ng-if="task.observacoes">
              <b>Comentário:</b>{{task.observacoes}}<br>
            </span>

            <b>Criado em </b>{{task.created_at | date:'dd/MM/yyyy \'às\' HH:mm'}}
          </p>

         <a class="text-white" ng-click="$root.openImageLightBox(task.imagens)" ng-if="task.imagens.length > 0"><u>Fotos</u></a>

          <div class="text-right" ng-if="task.status.descricao === 'atrasado' ||
                                          task.status.descricao === 'pendente' &&
                                          $root.permissions.tarefa.canManage">
            <br>
            <a class="text-white" ng-click="tarefas.showEditTask(task)"><u><i class="fa fa-cog" aria-hidden="true" ></i>Editar</u></a>
          </div>

        </uib-accordion-group>
        <div class="clearfix"></div>
      </div>
    </uib-accordion>
    <!-- Fim lista tarefas-->
  </div>
</div>
